import { api } from '../../api';
import FieldRoutePage from '../components/FieldRoutePage';

// My Sign Route — the technician's phone-first day view. Layout and the
// outcome flow live in FieldRoutePage (shared with the tagging route).
const CONFIG = {
  fetchRoute: params => api.getMySignRoute(params),
  submitOutcome: (id, fd) => api.submitSignOutcome(id, fd),
  completeTask: (id, fd) => api.completeSignTask(id, fd),
  summaryField: 'sign_work_summary',
  specialsLabel: 'Special signs',
};

export default function SignRoutePage() {
  return <FieldRoutePage config={CONFIG} />;
}
